<template>
    <nav class="navbar" role="navigation" aria-label="main navigation">
        <div id="usernav" class="lb-top-menu is-active" @click="toggleMenu">
            <div class="navbar-item has-dropdown">
                <a class="navbar-link is-arrowless py-3 is-size-6">
                    <span> {{ routeName }}</span
                    ><span class="icon is-small pl-3">
                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                    </span>
                </a>

                <div
                    :class="{ 'is-hidden': !dropdownActive }"
                    class="navbar-dropdown has-background-white floating pt-0"
                >
                    <router-link
                        v-t="'Community.feed'"
                        :to="{
                            name: 'community',
                        }"
                        exact
                        class="navbar-item has-text-weight-bold has-text-black py-3 is-size-6"
                    />

                    <div v-if="hasContent || isAdmin">
                        <hr
                            class="navbar-divider has-background-very-light-pink"
                        />
                        <router-link
                            v-t="'Community.content'"
                            :to="{
                                name: 'content',
                            }"
                            class="navbar-item has-text-weight-bold has-text-black py-3 is-size-6"
                        />
                    </div>

                    <!--
            <hr class="navbar-divider has-background-very-light-pink" />
          <router-link
            v-t="'Community.digital_environment'"
            :to="{
              path: '/community/'+community._id+'/environment'
            }"
            exact
            class="navbar-item has-text-weight-bold has-text-black py-3 is-size-6"
          />
         -->

                    <hr class="navbar-divider has-background-very-light-pink" />
                    <router-link
                        v-t="'Community.participants'"
                        :to="{
                            name: 'participants',
                        }"
                        exact
                        class="navbar-item has-text-weight-bold has-text-black py-3 is-size-6"
                    />

                    <!--
          <hr class="navbar-divider has-background-very-light-pink" />
          <router-link
            v-t="'Community.agora'"
            :to="{
              path: '/community/'+community._id+'/forum'
            }"
            exact
            class="navbar-item has-text-weight-bold has-text-black py-3 is-size-6"
          />
          -->
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            dropdownActive: false,
        };
    },
    computed: {
        community() {
            return this.$store.getters.community;
        },
        routeName() {
            if (this.$route.query.filter)
                return this.$t('Dashboard.' + this.$route.query.filter);
            else {
                return this.community.title;
            }
        },
        hasContent() {
            if (this.community.activities && this.community.activities.length) {
                return true;
            }
            return false;
        },
        hasCourses() {
            if (this.community.courses && this.community.courses.length) {
                return true;
            }
            return false;
        },
        isAdmin() {
            return this.community.accessLevel == 'administrator';
        },
    },
    methods: {
        toggleMenu() {
            this.dropdownActive = !this.dropdownActive;
        },
    },
};
</script>

<style scoped lang="sass">
.floating
  position: absolute
  width: 100%
  top: 0

#usernav .navbar-divider
  display: block
  width: 85%
  margin: 0 auto
  height: 1px

#usernav .navbar-link.is-arrowless .icon
  vertical-align: middle
</style>
